/**
 * @fileoverview UserAccountMenuItem — thin wrapper over Blueprint's
 * `<MenuItem>` for rows in the UserAccountMenu popover (Settings, Log out,
 * etc.). Defaults to `bp6-popover-dismiss` behaviour and forwards
 * `icon`/`text`/`href`/`onClick`. Exists so the user-menu surface stays
 * cohesive without consumers reaching directly into Blueprint.
 *
 * Foundry mapping: `bp6-menu-item bp6-popover-dismiss` (anchor variant when
 * `href` is provided, button variant otherwise).
 */

import { MenuItem, type IconName } from "@blueprintjs/core";
import type { ReactElement } from "react";

interface UserAccountMenuItemProps {
  icon?: IconName;
  text: string;
  href?: string;
  onClick?: () => void;
  className?: string;
}

export function UserAccountMenuItem({
  icon,
  text,
  href,
  onClick,
  className,
}: UserAccountMenuItemProps): ReactElement {
  return (
    <MenuItem data-testid="user-account-menu-item"
      icon={icon}
      text={text}
      href={href}
      onClick={onClick}
      className={["bp-user-account-menu-item", className].filter(Boolean).join(" ")}
      shouldDismissPopover
    />
  );
}
